import React from 'react'
import { Box, Border, Heading, Image } from 'rebass'
import { HTMLContent } from '../components/Content'

const Footer = ({ content }) => (
  <Border border={0} borderColor="#4BC169" borderTop={1}>
    <Box my={4} py={3}>
      <HTMLContent
        className="content"
        content={content}
        style={{ width: '100%' }}
      />
    </Box>
  </Border>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js